import * as DateFns from 'date-fns'
import toTimestamp from './toTimestamp'

function isFreeUser(user) {
  const expirationDate = user.licence_configuration && user.licence_configuration.expiration_date
  const isFreeUserLicence =
    user.licence_configuration &&
    user.licence_configuration.base_template &&
    user.licence_configuration.base_template.code === 'FREE' &&
    !user.licence_configuration.code_pad &&
    user.licence_configuration.monthly_annotations > 0

  return !!(
    isFreeUserLicence ||
    (expirationDate &&
      toTimestamp(DateFns.endOfDay(new Date(expirationDate))) < toTimestamp(Date()))
  )
}

export default isFreeUser
